import React from 'react';
import JobSingle from './JobSingle';
import './../scss/App.scss';

//api calls
import jobstreamurl from '../api/jobs.js'
import axios from 'axios'

class App extends React.Component {

  state = {
    jobId: '',
    jobs: [],
    socialshares: [],
    SingleJobselectionData: [],
    isLoading: false,
  }

  constructor(props) {
    super(props);
    this.state = {
      jobId: props.jobId,
      SingleJobselectionData: props.SingleJobselectionData,
    };
  }

  componentDidMount() {
    console.log('inside mount');
    this.fetchJobstreamUrl();
    this.initCTAFooterAware();
  }

  componentWillUnmount() {
    if (this._ctaInterval) {
      clearInterval(this._ctaInterval);
    }
    if (this._scrollHandler) {
      window.removeEventListener('scroll', this._scrollHandler);
      window.removeEventListener('resize', this._scrollHandler);
    }
  }

  initCTAFooterAware = () => {
    const self = this;
    let attempts = 0;
    let cta = null;
    let footer = null;

    const clearCTAStyles = () => {
      if (cta) {
        cta.style.position = '';
        cta.style.bottom = '';
      }
    };

    const handleScroll = () => {
      if (window.innerWidth >= 768) {
        clearCTAStyles();
        return;
      }
      if (!cta || !footer) return;

      const footerTop = footer.getBoundingClientRect().top + window.scrollY;
      const viewportBottom = window.scrollY + window.innerHeight;

      if (viewportBottom >= footerTop) {
        cta.style.position = 'absolute';
        cta.style.bottom = '0px';
      } else {
        cta.style.position = 'fixed';
        cta.style.bottom = '1rem';
      }
    };

    this._ctaInterval = setInterval(function () {
      attempts++;

      cta = document.querySelector('.job-meta-box .cta-link');
      footer = document.querySelector('.wp-block-group.footer');

      if (cta && footer) {
        clearInterval(self._ctaInterval);

        self._scrollHandler = handleScroll;

        window.addEventListener('scroll', self._scrollHandler);
        window.addEventListener('resize', self._scrollHandler);
        self._scrollHandler();
      }

      if (attempts > 50) {
        clearInterval(self._ctaInterval);
      }
    }, 100);
  };

  fetchJobstreamUrl = async () => {
    console.log('inside fetchJobstreamUrl');
    this.setState({
      jobstreamurl : "",
    },
      this.fetchAllData
    );
  }

  fetchJobs = async (id) => {
    console.log('inside fetchJobs: ' + this.state.jobId);
    this.setState({ isLoading: true });
    const response = await axios.get(
      "/wp-json/macs/v1/single-job-api" + '?cg_job_id=' + this.state.jobId
    ).then(response =>
      this.setState({
        jobs : response.data,
        isLoading: false,
      },
        this.fetchSocialShareIcons
      )
    ).catch(() => {
      this.setState({ isLoading: false });
    });
  }

  fetchAllData = async () => {
    this.fetchJobs();
  }

  fetchSocialShareIcons = async () => {
    const response = await axios.get(
      '/wp-json/macs/v1/socialshareurls'
    ).then(response =>
      this.setState({
        socialshares : response.data,
      })
    );
  }

  render() {
    return (
      <div className="single-job">
        {this.state.isLoading ? (
          <div className="jobs-preloader" role="status" aria-live="polite" aria-busy="true">
            <span className="jobs-preloader__spinner" aria-hidden="true"></span>
          </div>
        ) : ( (typeof this.state.jobs === 'undefined' || ( this.state.jobs._id !== undefined && this.state.jobs.deleted_at !== null )) ) ? (
          <div></div>
        ) : (
          <React.Fragment>
            <JobSingle jobs={this.state.jobs} socialshares={this.state.socialshares} SingleJobselectionData={this.state.SingleJobselectionData} />
          </React.Fragment>
        )}
      </div>
    );
  }
}

export default App;